import React from 'react';
import './loading.css';

export const Loading = () => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999,
                background: 'var(--global-cor-bg)',
                opacity: '0.9',
            }}
        >
            <div className="d-flex align-items-center justify-content-center" style={{ height: '100%', zIndex: 0 }}>
                <div className="loader"></div>
            </div>
        </div>
    );
};
